<template>
  <v-dialog
    v-model="active"
    :width="modalSize == 'small' ? 570 : 880"
    persistent
  >
    <v-card class="px-6 py-5" style="border-radius:10px">
      <v-card-title class="pa-0 shadow-1">
        <div class="d-flex flex-row justify-space-between" style="width:100%">
          <div class="title-modal">{{ title }}</div>
          <v-icon
            color="rgba(0, 0, 0, 0.56)"
            @click="() => closeModal()"
            style="margin-right:-6px ;"
          >
            mdi-close
          </v-icon>
        </div>
      </v-card-title>
      <v-divider class="my-2"></v-divider>

      <div class="text-modal my-4" v-if="text">{{ text }}</div>
      <slot></slot>

      <v-card-actions class="px-0 justify-end" v-if="actionBtn || cancelBtn">
        <v-btn
          class="outline-btn mr-3"
          style="height: 32px !important;"
          :disabled="loading"
          @click="() => closeModal()"
          v-if="cancelBtn"
        >
          CANCELAR
        </v-btn>
        <v-btn
          class="blue-btn"
          style="height: 32px !important;"
          :loading="loading"
          :disabled="loading"
          @click="HandlerAction"
          v-if="actionBtn"
        >
          {{ actionText }}
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  props: {
    active: {
      type: Boolean,
      required: true,
      default: false,
    },
    action: {
      type: Function,
      required: false,
      default: () => {},
    },
    closeModal: {
      type: Function,
      required: true,
      default: () => {},
    },
    cancelBtn: {
      type: Boolean,
      required: false,
      default: true,
    },
    actionBtn: {
      type: Boolean,
      required: false,
      default: true,
    },
    actionText: {
      type: String,
      required: false,
      default: "ACEPTAR",
    },
    title: {
      type: String,
      require: false,
      default: "",
    },
    text: {
      type: String,
      require: false,
      default: "",
    },
    modalSize: {
      type: String,
      require: false,
      default: "small",
    },
    loading : {
      type: Boolean,
      require: false,
      default: false,
    },
  },

  methods: {
    async HandlerAction() {
      this.loading = true;
      await this.action();
      this.loading = false;
    },
  },
};
</script>

<style>
.title-modal {
  font-weight: 500;
  font-size: 20px;
  color: #343ec4;
  line-height: 26px;
}
.text-modal {
  font-size: 16px;
  font-weight: 500;
  color: rgba(0, 0, 0, 0.6);
}
.blue-btn {
  height: 42px !important;
  background-color: #343ec4 !important;
  color: white !important;
  font-size: 13px !important;
}
.outline-btn {
  height: 42px !important;
  background-color: white !important;
  color: #343ec4 !important;
  border: solid 1px #343ec4;
  font-size: 13px !important;
}
</style>
